import { render } from "./RbDataTable.vue?vue&type=template&id=b8cc1dce&scoped=true"
import script from "./RbDataTable.vue?vue&type=script&lang=js"
export * from "./RbDataTable.vue?vue&type=script&lang=js"

import "./RbDataTable.vue?vue&type=style&index=0&id=b8cc1dce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8cc1dce"]])

export default __exports__